<template>
  <three-d-viewer :type="'brain'" :id="$route.params.brain_id" />
</template>

<script>
import ThreeDViewer from '@/components/ThreeDViewer.vue'

export default {
  title: '3d-viewer',
  components: {
    ThreeDViewer,
  },
  data: () => ({}),
}
</script>
